import styled from 'styled-components'

const PageActionWrapper = styled.div`
  margin-top: var(--bq-spacing-l);
  width: 100%;
  display: flex;
  align-items: center;
  gap: var(--bq-spacing-xs);
  padding: var(--bq-spacing-xs);
  border-radius: var(--bq-radius--m);
  background-color: var(--bq-ui--alt);
  @media screen and (max-width: 1395px) {
    margin-top: var(--bq-spacing-xs);
  }
`

export default PageActionWrapper
